import React from 'react';
import ReactDOM from 'react-dom';
import { APP_ROOT_ID, HEADER_BASE_CONFIG } from '../constants';
import { makePluginsRunner } from '../pluginsRunner';
import { getDeviceType, getValueForDevice } from '../utils';
import { App } from './App';
import { pluginsRegistry } from '../plugins-registry';

export const init = async ({ krakenConfig }) => {
  const { productConfig, content, locale, headerType, plugins, productSource, vertical, headerless, buildVertical } = krakenConfig;

  const headerRenderers = [];
  
  const pluginsRunner = makePluginsRunner({
    productSource: getValueForDevice(productSource),
    plugins,
    productConfig,
    locale,
    deviceType: getDeviceType(),
    headerType,
    header: HEADER_BASE_CONFIG,
    headerRenderers,
    vertical,
    pluginsRegistry,
  });

  if (headerless) return;

  pluginsRunner.beforeRender();

  ReactDOM.render(
    <App
      headerType={headerType}
      headerConfig={HEADER_BASE_CONFIG}
      content={content}
      headerRenderers={headerRenderers}
      jurisdiction={productConfig.jurisdiction}
      locale={locale}
      buildVertical={buildVertical}
    />,
    document.getElementById(APP_ROOT_ID)
  );

  pluginsRunner.afterRender();
};
